// Logic taken from https://github.com/stevekinney/node-phone-formatter
/**
 * Normalizes and formats phone numbers
 * @param {string} phoneNumber Original number to be formatted
 * @param {string} [stringFormat=(NNN) NNN-NNNN] Outputted format
 */
const phoneNumberFormatter = function (phoneNumber) {
  let stringFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '(NNN) NNN-NNNN';
  const normalizedPhoneNumber = phoneNumber.replace(/^[+\d{1,3}\-\s]*\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, '$1$2$3');
  let formattedString = stringFormat;
  for (let i = 0, l = normalizedPhoneNumber.length; i < l; i += 1) {
    formattedString = formattedString.replace('N', normalizedPhoneNumber[i]);
  }
  return formattedString;
};

/* eslint no-param-reassign: 0 */
const formatCurrency = value => {
  if (!value) {
    value = '0';
  }
  if (typeof value === 'string') {
    value = value.replace(/,/g, '');
  }
  value = parseFloat(value);
  return Number.isNaN(value) ? '0.00' : value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
const unformatCurrency = value => {
  if (typeof value === 'string') {
    value = value.replace(/,/g, '');
  }
  return parseFloat(value);
};

export { formatCurrency, phoneNumberFormatter, unformatCurrency };
//# sourceMappingURL=formatters.js.map
